import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import GoogleAuth from '../components/GoogleAuth';

import './Landing.scss';

class Landing extends Component {

    render() {
        return (
            <div>
                <div className="full-screen">
                <div>
                    <h1>create a shirt</h1>
                    <br/>
                    {/* <GoogleAuth /> */}
                    <Link className="button-line" to="/create">{`start now`}</Link> 
                </div>
                </div>
            </div>
        );
    }
}

export default Landing;